import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../pages/Styles.module.css"; 
import modalStyles from "./Modals/Modal.module.css";

// ÍCONES
import { Menu, LogOut, LayoutDashboard, Globe, X, Settings } from "lucide-react";
import { LiaUniversitySolid } from "react-icons/lia";

import axiosInstance from "../services/axiosInstance";
import { getSessionId, getTabId, logout as doLogout } from "../utils/auth";
import { usePainelSocket, useSessionSocket } from "../pages/contexts/SocketContext";
import { mapToCanonicalRole } from "../utils/roleMap";

// Modal Logout Interno
function ConfirmLogoutModal({ open, onConfirm, onCancel }) {
    if (!open) return null;
    return (
        <div className={modalStyles.modalOverlay} style={{zIndex: 9999}}>
            <div className={modalStyles.modalMenu}>
                <div className={modalStyles.modalHeader}><h2 className={modalStyles.modalTitle}>Confirmar saída</h2></div>
                <div className={modalStyles.modalBody}><p>Deseja realmente sair do sistema?</p></div>
                <div className={modalStyles.modalFooter} style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                    <button className={modalStyles.btnStop} onClick={onCancel}>Cancelar</button>
                    <button className={modalStyles.encerrarVotacao} onClick={onConfirm}>Sair</button>
                </div>
            </div>
        </div>
    );
}

const DockMenu = () => {
    const navigate = useNavigate();
    const dropdownRef = useRef(null);
    const [showMenu, setShowMenu] = useState(false);
    const [showLogoutModal, setShowLogoutModal] = useState(false);

    // Sockets
    const painelSocket = usePainelSocket();
    const sessionSocket = useSessionSocket();

    // Permissões
    const cargoUsuario = localStorage.getItem("role") || "vereador";
    const roleCanonical = mapToCanonicalRole(cargoUsuario);
    const isAdmin = ['admin', 'root', 'presidente', 'secretario', 'servidor'].includes(roleCanonical);

    // Click Outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setShowMenu(false);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const realizarLogout = async () => {
        try { await axiosInstance.post("/auth/logout", { sessionId: getSessionId(), tabId: getTabId() }); } catch (e) { console.warn(e); } 
        finally {
            try { sessionSocket?.disconnect(); painelSocket?.disconnect(); } catch {}
            doLogout();
            window.location.replace("/login");
        }
    };

    const menuItemStyle = {
        display: 'flex', alignItems: 'center', gap: 10, padding: '12px 16px', 
        border: 'none', background: 'transparent', width: '100%', 
        textAlign: 'left', cursor: 'pointer', color: '#333', justifyContent: "space-between",
    };

    return (
        <div style={{ position: 'relative' }} ref={dropdownRef}>
            <button 
                style={{ 
                    display: 'flex', alignItems: 'center', gap: 6, opacity: showMenu ? 1 : 0.8,
                    padding: '8px', borderRadius: '4px', boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                    backgroundColor: showMenu ? '#f0f0f0' : '#fff', color: '#333'
                }}
                onClick={() => setShowMenu(!showMenu)}
                title="Menu Principal"
            >
                {showMenu ? <X className={styles.btnStop} size={24} /> : <Menu className={styles.btnPause} size={24} />}
            </button>

            {showMenu && (
                <div className={styles.menuDropdown} style={{
                    position: 'absolute', top: '120%', right: 0, width: 'max-content',
                    backgroundColor: '#fff', boxShadow: '0 5px 20px rgba(0,0,0,0.2)',
                    borderRadius: '8px', padding: '5px 0', zIndex: 1000,
                    display: 'flex', flexDirection: 'column', border: '1px solid #eee'
                }}>
                    
                    {/* HOME */}
                    <button onClick={() => navigate("/dashboard")} style={menuItemStyle} className={styles.menuItemHover}>
                        <LiaUniversitySolid size={22} color="#336699" /> Plenário Virtual
                    </button>

                    {/* LINKS ADMINISTRATIVOS */}
                    {isAdmin && (
                        <>
                            <div style={{ height: 1, backgroundColor: '#eee', margin: '4px 0' }}></div>
                            
                            <button onClick={() => navigate("/config-camara?tab=painelcontrole")} style={menuItemStyle} className={styles.menuItemHover}>
                                <LayoutDashboard size={20} color="#e67e22" /> Painel de Controle
                            </button>

                            <button onClick={() => navigate("/config-camara")} style={menuItemStyle} className={styles.menuItemHover}>
                                <Settings size={20} color="#555" /> Menu principal
                            </button>
                        </>
                    )}

                    <div style={{ height: 1, backgroundColor: '#eee', margin: '4px 0' }}></div>

                    {/* COMUNS */}
                    <button onClick={() => window.open('/portal', '_blank')} style={menuItemStyle} className={styles.menuItemHover}>
                        <Globe size={20} color="#27ae60"/> Portal Público
                    </button>

                    <button 
                        onClick={() => { setShowMenu(false); setShowLogoutModal(true); }}
                        style={{ ...menuItemStyle, color: '#c62828' }}
                        className={styles.menuItemHover}
                    >
                        <LogOut size={20} /> Sair
                    </button>
                </div>
            )}

            <ConfirmLogoutModal open={showLogoutModal} onConfirm={realizarLogout} onCancel={() => setShowLogoutModal(false)} />
        </div>
    );
};

export default DockMenu;